import { useState, useEffect, useMemo } from 'react';
import { ServiceRequest } from '@medplum/fhirtypes';
import { MedplumClient } from '@medplum/core';
import { useGenericResourceSearch } from '@/hooks/useGenericResourceSearch';
import { ConsentStatus } from '@/types/consent.types';
import {
  ORDER_SEARCH_DEFAULTS,
  orderSearchConfig,
  type OrderSearchParams,
} from '../orders/orderSearchConfig';

export type { OrderSearchParams };
export { ORDER_SEARCH_DEFAULTS };

export function useOrderSearch(medplum: MedplumClient, patientId?: string) {
  const baseSearch = useGenericResourceSearch<
    OrderSearchParams,
    ServiceRequest
  >(medplum, orderSearchConfig, patientId);

  const [consentStatuses, setConsentStatuses] = useState<
    Map<string, ConsentStatus>
  >(new Map());

  useEffect(() => {
    if (baseSearch.bundleData?.consentStatuses) {
      setConsentStatuses(baseSearch.bundleData.consentStatuses);
    } else {
      const defaultMap = new Map<string, ConsentStatus>();
      baseSearch.resources.forEach((order) => {
        if (order.id) {
          defaultMap.set(order.id, 'not-answered');
        }
      });
      setConsentStatuses(defaultMap);
    }
  }, [baseSearch.bundleData, baseSearch.resources]);

  return useMemo(
    () => ({
      ...baseSearch,
      consentStatuses,
    }),
    [baseSearch, consentStatuses]
  );
}
